export const FETCH_CAPABILITIES_LOADING = 'FETCH_CAPABILITIES_LOADING';
export const FETCH_CAPABILITIES_SUCCESS = 'FETCH_CAPABILITIES_SUCCESS';
export const FETCH_CAPABILITIES_FAILED = 'FETCH_CAPABILITIES_FAILED';
